import { Durations } from '@ptml/design-system';
import { useEffect, useRef, useState } from 'react';

export const useCountUp = (
    target: number,
    duration = Durations.short150,
): number => {
    const [value, setValue] = useState(target);
    const startRef = useRef<number | null>(null);
    const fromRef = useRef(target);
    const rafRef = useRef<number | null>(null);

    useEffect(() => {
        fromRef.current = value;
        startRef.current = null;

        const animate = (timestamp: number) => {
            if (startRef.current === null) startRef.current = timestamp;
            const elapsed = timestamp - startRef.current;
            const progress = Math.min(elapsed / duration, 1);
            setValue(fromRef.current + (target - fromRef.current) * progress);
            if (progress < 1) rafRef.current = requestAnimationFrame(animate);
        };

        rafRef.current = requestAnimationFrame(animate);
        return () => {
            if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
        };
    }, [target, duration]);

    return value;
};
